// Backbone View for tooltips
var $ = jQuery;
var GroupTooltipFont = Backbone.View.extend({
    initialize: function (options) {
        this.options = options; // we set current block on call, so we need options array to bind data properly
        _.bindAll(this, 'bindings');
    },
    bindings: function () {
        var result = {};
        var layout = model.get('layout');
        var field = this.options.field_name;
        var field_model = 'styles.' + layout + '.' + field;
        result['[name="group_' + field + '_font_size"]'] = field_model + '_font_size'; // block font size
        result['[name="group_' + field + '_color"]'] = field_model + '_color'; // block text color
        result['[name="group_' + field + '_bold"]'] = field_model + '_bold'; // block bold
        result['[name="group_' + field + '_italic"]'] = field_model + '_italic'; // block italic
        result['[name="group_' + field + '_text_transform"]'] = field_model + '_text_transform'; // block text transform
        result['[name="group_' + field + '_align"]'] = field_model + '_align'; // block align
        result['[name="group_' + field + '_top_margin"]'] = field_model + '_top_margin'; // block top margin

        result['.btn-group-align'] = {
            observe: field_model + '_align',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                $el.find('input').val(val);
                $el.find('.' + this.options.field_name + '_align_' + val).addClass('active');
            }
        };
        result['.btn-bold'] = {
            observe: field_model + '_bold',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                if(!!+val){
                    $el.addClass('active');
                }
            }
        };
        result['.btn-italic'] = {
            observe: field_model + '_italic',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                if(!!+val){
                    $el.addClass('active');
                }
            }
        };
        result['.btn-group-text-transform'] = {
            observe: field_model + '_text_transform',
            update: function($el, val, model, options){
                $el.find('.btn').removeClass('active');
                $el.find('input').val(val);
                $el.find('.' + this.options.field_name + '_text_transform_' + val).addClass('active');
            }
        };
        return result;
    },
    render: function(){
        this.stickit();
        return this;
    },
    close: function(){
        this.unstickit();
        //delete this.$el;
        //delete this.el;
    }
});